import {formatDate} from "../../modules/ui/components/AppMenu/redux/utils";

export function normalizeResponse(res) {
    if (res['created_at']) {
        res['created_at'] = formatDate(res['created_at']);
    }
    if (res['retention_date']) {
        res['retention_date'] = formatDate(res['retention_date']);
    }
    if (res['last_updated']) {
        res['last_updated'] = formatDate(res['last_updated']);
    } else {
        res['last_updated'] = 'Not modified'
    }
    if (res['expire_date']) {
        res['expire_date'] = formatDate(res['expire_date']);
    }
    res['id'] = res['resource_id'];
    return res;
}

export function getLastPath(path) {
    if (!!path) {
        let paths = path.split('/')
        if (!!paths && path.length > 0) {
            return paths[paths.length - 1]
        }
    }
    return ''
}

export function getValueFromStateOrPayloadAction(key: str, state, payload) {
    // There are 3 cases with the sort
    // 1. Clearing - 2. Not used - 3. Using
    return (JSON.stringify(payload) === '{}' || payload === null)
        ? undefined
        : payload === undefined
            ? state[key]
            : payload;
}